import { useQuery } from '@hooks/reactQuery';

import { getPortalTimelineAssigneesForFilter } from '@api/portalTimeline';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { PORTAL_TIMELINE_ASSIGNEES_FILTER } from '@constants/queryKeys';

interface IUseQueryTimelineAssigneesReturned {
	portalTimelineAssigneesFilter: TNameTitleValueLabel[];
	isLoadingPortalTimelineAssigneesFilter: boolean;
}

export const useQueryPortalTimelineAssigneesFilter = (projectId?: string): IUseQueryTimelineAssigneesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_TIMELINE_ASSIGNEES_FILTER, projectId],
		queryFn: extractQueryParams(getPortalTimelineAssigneesForFilter),
		select: requestTypes => projectUsersFormatted(requestTypes),
		enabled: [!!projectId],
		...refetchOptions,
	});

	return {
		portalTimelineAssigneesFilter: data || [],
		isLoadingPortalTimelineAssigneesFilter: isLoading || isFetching,
	};
};
